export const html: string = `<div data-book-id="{{ bookId }}"
	data-myon-on-click="handleControlFocused"
	data-ui-name="book"
	role="group"
	aria-roledescription="{{ lang.BOOK_ROLE_DESCRIPTION }}"
	aria-labelledby="book-{{ bookId }}-title"
	data-ui-book-id="{{ bookId }}"
	data-myon-attr-class="book {{ lengthClass }} {{ focused? | '-focused' }} {{ card? | '-card' }} {{ row? | '-row' }} {{ checkbox? | '-checkbox' }}">
	<div class="book_cell -checkbox" data-myon-if="{{ checkbox }}">
		<input data-myon-name="checkbox" aria-label="{{ lang.ACTION_SELECT }}" data-myon-on-change="handleCheckChange" class="checkbox" name="book[]" type="checkbox" value="{{ bookId }}" />
	</div>
	<div class="book_cell -cover" data-myon-name="coverCell">
		<div class="book_cover" data-myon-name="cover">
			<div data-myon-if="{{ flagLabel }}" data-myon-attr-class="mediaFlag {{ flagClass }}">
				<div class="mediaFlag_icon">{{ flagIcon? @noescape }}</div>
				<div class="mediaFlag_label">{{ flagLabel }}</div>
			</div>
			<div class="book_coverImgRatioFix" data-myon-name="imgRatioFix">
				<div class="book_page -backCover"></div>
				<div class="book_page -n4"></div>
				<div class="book_page -n3"></div>
				<div class="book_page -n2"></div>
				<div class="book_page -n1"></div>
				<img draggable="false" data-myon-name="img" class="book_coverImg" alt="{{ title | getCoverAlt }}" />
			</div>
			<div data-myon-if="{{ ribbonTitle }}" class="book_ribbon" data-myon-name="ribbon">
				<div data-myon-if="{{ ribbonLabel }}" class="book_ribbonLabel">{{ ribbonLabel }}</div>
				<div class="book_ribbonTitle">{{ ribbonTitle }}</div>
			</div>
		</div>
	</div>
	<div class="book_cell -title">
		<button id="book-{{ bookId }}-title" lang="{{ langString }}" type="button" class="book_title link" data-myon-click="handleInfoClicked">{{ title }}</button>
	</div>
	<div class="book_cell -description">
		<div class="book_description" lang="{{ langString }}">{{ description }}</div>
	</div>
	<div class="book_cell -listMetrics">
		<dl class="book_data">
			<div class="book_dataGroup -list" data-myon-template="listMetrics">
				<dt class="book_dataLabel">{{ metric.label }}</dt>
				<dd class="book_dataValue" data-ui-name="{{ metric.label }}" data-ui-book-id="{{ bookId }}">{{ metric | formatMetricValue }}</dd>
			</div>
		</dl>
	</div>
	<div class="book_cell -listLabels">
		<dl class="book_data -labels">
			<div class="book_dataGroup -labels" data-myon-template="listLabels">
				<dt class="book_dataLabel">{{ metric.label }}</dt>
				<dd class="book_dataValue" data-ui-name="{{ metric.label }}" data-ui-book-id="{{ bookId }}">{{ metric | formatMetricValue @noescape }}</dd>
			</div>
		</dl>
	</div>
	<div class="book_cell -controls">
		<div class="book_controls -floating" data-myon-name="controls">
			<button type="button"
				class="button book_control -read"
				aria-label="{{ lang.ACTION_OPEN_LONG }}"
				data-myon-focus="handleControlFocused"
				data-myon-blur="handleControlBlurred"
				data-ui-name="bookRead"
				data-ui-book-id="{{ bookId }}"
				data-myon-click="handleReadButtonClicked">
				<i class="button_icon mycon -read-book book_buttonIcon -read"></i>
				<span class="button_text book_buttonText -read">{{ lang.ACTION_OPEN }}</span>
			</button>
			<button type="button"
				data-myon-if="{{ arQuizAvailable }}"
				class="button -ar book_control"
				aria-label="{{ lang.ACTION_AR_QUIZ }}"
				data-myon-focus="handleControlFocused"
				data-myon-blur="handleControlBlurred"
				data-myon-on-click="handleArQuizButtonClicked"
				data-ui-name="bookArQuiz"
				data-ui-book-id="{{ bookId }}">
				<i class="button_icon mycon book_buttonIcon -ar" data-myon-if="{{ row }}"></i>
				<span class="g_screenReader" data-myon-if="{{ row }}">{{ lang.ACTION_AR_QUIZ }}</span>
				<span class="button_text book_buttonText -ar" data-myon-if="{{ card }}">{{ lang.ACTION_AR_QUIZ }}</span>
			</button>
			<button type="button"
				class="button book_control -info"
				aria-label="{{ lang.ACTION_INFO_LONG }}"
				data-myon-focus="handleControlFocused"
				data-myon-blur="handleControlBlurred"
				data-ui-name="bookInfo"
				data-ui-book-id="{{ bookId }}"
				data-myon-click="handleInfoClicked">
				<i class="button_icon mycon -info book_buttonIcon -info" data-myon-if="{{ row }}"></i>
				<span class="g_screenReader">{{ lang.ACTION_INFO }}</span>
				<span class="button_text book_buttonText -info" data-myon-if="{{ card }}">{{ lang.ACTION_INFO }}</span>
			</button>
			<button type="button"
				data-myon-attr-class="button book_control {{ isOnMyList? | '-removeFromList -checked' }} {{ !isOnMyList? | '-addToList' }}"
				aria-pressed="{{ isOnMyList? | 'true' }}{{ !isOnMyList? | 'false' }}"
				data-myon-if="{{ showMyList }}"
				data-myon-name="myListButton"
				aria-label="{{ isOnMyList | getMyListTitle }}"
				data-myon-focus="handleControlFocused"
				data-myon-blur="handleControlBlurred"
				data-ui-name="bookMyList"
				data-ui-inList="{{ isOnMyList? | '1' }}{{ !isOnMyList? | '0' }}"
				data-ui-book-id="{{ bookId }}"
				data-myon-click="handleMyListButtonClicked">
				<i data-myon-attr-class="button_icon book_buttonIcon -mylist mycon {{ isOnMyList? | '-mylist-remove-check' }} {{ !isOnMyList? | '-mylist-add-plus' }}"></i>
				<span class="g_screenReader">{{ isOnMyList | getMyListLabel }}</span>
			</button>
		</div>
	</div>
	<ul class="book_cell -details" data-myon-if="{{ details.length }}">
		<li data-myon-template="details" class="book_flag">
			{{ element @noescape }}
		</li>
	</ul>
</div>`;
